/* ------------------------------------------------------------------------------------------------------------
Item Purchase Limit
* ------------------------------------------------------------------------------------------------------------*/

const skuLimit = 5 || 5;

const getItemCounts = async () => {
  try {
    const response = await fetch('/cart.js');
    const data = await response.json();
    const { items = [] } = data || {};
    const itemCounts = {};

    items.forEach((item) => {
      const { quantity, id, handle } = item;
      const isGift = handle?.includes('gift-card');
      if (isGift) return;
      itemCounts[id] ? (itemCounts[id] += quantity) : (itemCounts[id] = quantity); 
    });

    return itemCounts;
  } catch (error) {
    console.error('Error fetching cart data:', error);
    throw error;
  }
};

const updateQuickAddButtons = (cartCount) => {
  document.querySelectorAll('form[action="/cart/add"]')?.forEach((form) => {
    if (form.dataset.isGc === 'true') return;
    const variantId = form.querySelector('input[name="id"]')?.value;
    const cartQty = cartCount[variantId];
    if (!cartQty) return;

    const maxQty = skuLimit - cartQty;
    const atcButton = form.querySelector('button[type="submit"]');
    const atcLabel = atcButton?.querySelector('[data-og-text]');
    const qtyInput = form.querySelector('input[name="quantity"]');
    
    if (qtyInput) {
      qtyInput.setAttribute('max', maxQty);
      qtyInput.value = maxQty > 0 ? 1 : 0;
    }
    
    if (atcButton) {
      atcButton.classList.toggle('button--ternary', maxQty <= 0);
      atcButton.toggleAttribute('disabled', maxQty <= 0);
    }
    
    if (atcLabel) {
      atcLabel.textContent = maxQty > 0 ? atcLabel.dataset.ogText || 'ADD TO CART' : `Limited to ${skuLimit}`;
    }
  });
};

const updateQtyButtons = (qtySelector, cartCount) => {
  const formContainer = qtySelector?.closest('.product-form__form-container');
  const form = formContainer?.querySelector('form[action="/cart/add"]');
  if (!form || form.dataset.isGc === 'true') return;

  const variantId = formContainer.querySelector('input[name="id"]')?.value;
  const buttons = qtySelector.querySelectorAll('button');
  const input = qtySelector.querySelector('input');
  if (!variantId || buttons.length <= 1 || !input) return;

  const maxQty = skuLimit - (cartCount[variantId] || 0);
  input.setAttribute('max', maxQty);
  input.value = 1;

  if (input.value >= maxQty) {
    buttons[1].setAttribute('disabled', true);
  } else {
    buttons[1].removeAttribute('disabled');
  }
};

const updateAjaxLineItemQty = () => {
  setTimeout(() => {
    const cartItems = Rebuy.SmartCart.items() || [];
    cartItems.forEach(item => {
      const isGift = item?.handle?.includes('gift-card');
      if (isGift) return;
      if (item?.quantity > skuLimit) {
        Rebuy?.Cart?.setItemQuantity(item, skuLimit)
      }
    })
  }, 400);
}

const applyLimit = async () => {
  const cartCount = await getItemCounts();
  updateQuickAddButtons(cartCount);
  return cartCount;
};

document.addEventListener("DOMContentLoaded", applyLimit);
document.addEventListener('rebuy:cart.change',() => {applyLimit();updateAjaxLineItemQty()});
document.addEventListener('quick-buy-drawer:loaded', applyLimit);

document.addEventListener('quick-buy:variant:changed', async (e) => {
  const quantitySelector = e.detail?.quickBuyDrawer?.querySelector('quantity-selector');
  const cartCount = await applyLimit();
  if (quantitySelector) {
    updateQtyButtons(quantitySelector, cartCount);
  }
});

document.addEventListener('quantity-selector:initialized', async (e) => {
  const quantitySelector = e.detail?.quantitySelector;
  const cartCount = await applyLimit();
  if (quantitySelector) {
    updateQtyButtons(quantitySelector, cartCount);
  }
});